import Date from '@/shared/filters/Date'
import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'
import _set from 'lodash/set'

class Tab extends APIObject {
  constructor (options) {
    // Init
    super('DM', options)

    // Default variables
    this.tags = this.tags || {}
    this.description = this.description || ''
    this.tags.tags = this.tags.tags || []
    this.tags.reference = this.tags.reference || ''
    if (!Array.isArray(this.tags.tags)) this.tags.tags = []
    this.display_name = this.display_name || ''
  }

  assign (object) {
    super.assign(object)
    this.created_at = Date(this.created_at) || null
    this.updated_at = Date(this.updated_at) || null
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      '_type',
      '__socketId',
      'created_at',
      'updated_at',
      'created_by',
      'updated_by',
      'children',
      'name'
    ])
    return obj
  }

  async create () {
    return super.create({
      method: 'POST',
      url: 'v4/tabs'
    })
  }

  async save () {
    return super.save({
      method: 'PUT',
      url: `v4/tabs/${this._id}`
    })
  }

  async remove () {
    return this.request({
      method: 'DELETE',
      url: `v4/tabs/${this._id}`
    })
  }
}
class Tabs extends API {
  list (options = {}) {
    const output = (tabs) => {
      return tabs.map(tab => {
        try {
          return new Tab(tab)
        } catch (err) {
          console.error(err.stack)
          return null
        }
      }).filter(i => i)
    }

    return this.paginateCursor({
      method: 'get',
      url: 'v4/tabs',
      onProgress: (tabs) => {
        if (options?.onProgress) options.onProgress(output(tabs))
      }
    }).then(tabs => {
      return output(tabs)
    })
  }

  new (queryString) {
    const item = {}
    for (const key in queryString) {
      _set(item, key, queryString[key])
    }
    return new Tab(item)
  }
}

export default Tabs
export {
  Tab,
  Tabs
}
